import React, { useEffect, useState, useRef } from "react";
import drone_lab_icon from "../../assets/image/png/drone_lab_icon.png";
import loction_icon from "../../assets/image/png/loction.png";
import date_icon from "../../assets/image/png/date_ivon.png";
import training_icon1 from "../../assets/image/png/training_icon1.png";
import training_icon2 from "../../assets/image/png/training_icon2.png";
import training_icon4 from "../../assets/image/png/training_icon4.png";
import training_icon5 from "../../assets/image/png/training_icon5.png";
import { Link, useParams } from "react-router-dom";
import { Accordion } from "react-bootstrap";
import { toast } from "react-toastify";
import {Footer} from "../../shared";
import Navbar from "../homepage/Navbar";
import {
  getInstitutes,
  getSingleInstitutes,
} from "../../redux/slice/instituteSlice";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faClock,
  faScrewdriverWrench,
} from "@fortawesome/free-solid-svg-icons";
import { Header } from "../../shared";

const SingleTrainingInstitute = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();
  const { singleInstitutes, institutes } = useSelector(
    (state) => state.institute,
  );

  const [activeTab, setActiveTab] = useState(0);
  const [showFaq, setShowFaq] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [selectedWorkshop, setSelectedWorkshop] = useState(null);
  const [showEnrollForm, setShowEnrollForm] = useState(false);

  const handleWorkshopClick = (workshop) => {
    setSelectedWorkshop(workshop);
    setShowModal(true);
  };

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    address: "",
  });

  const handleOpenModal = (workshop) => {
    setSelectedWorkshop(workshop);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setShowEnrollForm(false);
    setSelectedWorkshop(null);
    setFormData({
      name: "",
      email: "",
      phone: "",
      address: "",
    });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!selectedWorkshop?._id) {
      toast.error("Workshop ID not found");
      return;
    }

    try {
      const response = await fetch(
        process.env.REACT_APP_API_URL +
          `/workshopEnrollment/${selectedWorkshop._id}/enroll`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        },
      );

      const data = await response.json();

      if (data.status === "success") {
        toast.success("Enrollment successful!");
        handleCloseModal();
      } else {
        toast.error("Failed to enroll: " + (data.message || "Unknown error"));
      }
    } catch (error) {
      console.error("Enrollment error:", error);
      toast.error("An error occurred while enrolling. Please try again.");
    }
  };

  //   const [dummyWorkshops, setDummyWorkshops] = useState([
  //   {
  //     _id: "1",
  //     title: "Drone Mapping Workshop",
  //     image: "https://via.placeholder.com/400x250?text=Workshop+1",
  //     location: "New Delhi",
  //     date: "2025-07-20",
  //     price: 1499,
  //   },
  //   {
  //     _id: "2",
  //     title: "Drone Repair & Maintenance",
  //     image: "https://via.placeholder.com/400x250?text=Workshop+2",
  //     location: "Mumbai",
  //     date: "2025-08-10",
  //     price: 1999,
  //   },
  // ]);

  // Refs for each section
  const sectionRefs = {
    Overview: useRef(null),
    courses: useRef(null),
    "training-gallery": useRef(null),
    faq: useRef(null),
    workshops: useRef(null),
  };

  const sections = {
    Overview: 0,
    courses: 1,
    "training-gallery": 2,
    faq: 3,
    workshops: 4,
  };

  useEffect(() => {
    dispatch(getSingleInstitutes(id));
    dispatch(getInstitutes({ page: 1 }));
  }, [id, dispatch]);

  useEffect(() => {
    window.scrollTo(0, 0);

    const observerOptions = {
      root: null,
      rootMargin: "0px",
      threshold: 0.5,
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const sectionId = entry.target.id;
        if (entry.isIntersecting) {
          setActiveTab(sections[sectionId]);
        }
      });
    }, observerOptions);

    Object.keys(sectionRefs).forEach((sectionId) => {
      const section = sectionRefs[sectionId].current;
      if (section) {
        observer.observe(section);
      }
    });

    return () => {
      Object.keys(sectionRefs).forEach((sectionId) => {
        const section = sectionRefs[sectionId].current;
        if (section) {
          observer.unobserve(section);
        }
      });
    };
  }, []);

  const handleTabClick = (tab) => {
    setActiveTab(tab);
    const sectionId = Object.keys(sections).find(
      (key) => sections[key] === tab,
    );
    const targetRef = sectionRefs[sectionId]?.current;

    if (targetRef) {
      targetRef.scrollIntoView({ behavior: "smooth" });
    } else {
      console.error(`Reference for ${sectionId} is null`);
    }
  };

  const handleFaqToggle = () => {
    setShowFaq(!showFaq);
  };

  const handleFaqScroll = () => {
    if (sectionRefs.faq.current) {
      sectionRefs.faq.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  const listItemStyle = {
    position: "relative",
    marginBottom: "5px",
    paddingLeft: "25px",
    lineHeight: "24px",
  };

  const bulletStyle = {
    position: "absolute",
    left: "0",
    top: "50%",
    transform: "translateY(-50%)",
    color: "#000",
    fontSize: "16px",
  };

  return (
    <>
      <div className="custom-color">
        <Header />
      </div>
      <div id="overview" className="custom-color" style={{ color: "#328CCD" }}>
        <div className="container">
          <div className="row py-5">
            <div
              className="col-lg-4 ps-3 ps-lg-5 custom_top mb-3 position-lg-sticky h-100 "
              style={{ color: "#328CCD" }}
            >
              <div
                className="training_detail_box bg-white p-4 custom-color "
                style={{ color: "#328CCD" }}
              >
                <TabLink
                  tabIndex={sections.Overview}
                  icon={training_icon1}
                  title="Overview"
                  activeTab={activeTab}
                  onClick={handleTabClick}
                />
                <TabLink
                  tabIndex={sections["training-gallery"]}
                  icon={training_icon4}
                  title="Infra & Equipments"
                  activeTab={activeTab}
                  onClick={handleTabClick}
                />
                <TabLink
                  tabIndex={sections.courses}
                  icon={training_icon2}
                  title="Courses"
                  activeTab={activeTab}
                  onClick={handleTabClick}
                  titleStyle={{ fontSize: "10px" }}
                />
                <TabLink
                  tabIndex={sections.workshops}
                  icon={training_icon2} // or a different icon if available
                  title="Workshops"
                  activeTab={activeTab}
                  onClick={handleTabClick}
                />

                <div
                  className="d-flex mt-3 cursor-pointer gap-3 align-items-center"
                  onClick={handleFaqScroll}
                >
                  <img width={23} src={training_icon5} alt="FAQs" />
                  <p
                    className={`mb-0 fs_18 fw-medium ff_inter ${activeTab === sections.faq ? "custom-color" : "color_darkgray"}`}
                  >
                    FAQs
                  </p>
                </div>

                {/* Institutes List Section */}
                {/* <div className="mt-5 mx-3">
                  <h4 className="fs_21 ff_inter fw-bold color_darkgray">
                    Institutes
                  </h4>
                  <ul className="list-unstyled mt-2">
                    {institutes.map((e) => (
                      <li key={e.id} style={listItemStyle}>
                        <span style={bulletStyle}>•</span>
                        <a
                          href="#"
                          onClick={() => navigate(`/training-institute/${e._id}`)}
                          className="text-dark text-decoration-none"
                        >
                          {e.instituteName}
                        </a>
                      </li>
                    ))}
                  </ul>
                </div> */}
              </div>
            </div>
            <div className="col-lg-8">
              <h4 className="fs_43 ff_inter fw-bold color_darkgray text-center text-md-start mb-4 mb-lg-5">
                About {singleInstitutes?.Institute?.instituteName}
              </h4>
              <div className="d-flex tab_btn py-2 px-3 pe-5 gap-3 mt-4 align-items-center rounded-3">
                <img
                  className="rounded-2"
                  width={40}
                  src={singleInstitutes?.Institute?.image || drone_lab_icon}
                  alt="institute_image"
                />
                <p className="mb-0 fs_17 ff_inter text-white fw-semibold">
                  {singleInstitutes?.Institute?.instituteName} -{" "}
                  {singleInstitutes?.Institute?.address}
                </p>
              </div>
              <p className="fs_17 ff_inter fw-normal color_dark_grey mt-4">
                {singleInstitutes?.Institute?.about}
              </p>

              {/* Display Courses */}
              {singleInstitutes?.Course?.length > 0 && (
                <div ref={sectionRefs.courses} id="courses">
                  <h4 className="fs_21 ff_inter fw-bold color_darkgray mt-5">
                    Courses By {singleInstitutes?.Institute?.instituteName}
                  </h4>
                  <div className="row mt-2">
                    {singleInstitutes?.Course?.map((obj, index) => (
                      <div key={index} className="col-md-6 mt-4">
                        <Link to={`/courses-details/${obj._id}`}>
                          <img
                            height={250}
                            className="w-100 rounded-top-4 object-fit-cover"
                            src={obj.image}
                            alt="course_image"
                          />
                          <div className="bg-white border-1 d-flex flex-column justify-content-between min_height_210 training_border p-3 rounded-bottom-4">
                            <h4 className="fs_21 fw-bold ff_inter color_darkgray mb-0">
                              {obj.courseName}
                            </h4>
                            <div>
                              <div className="d-flex gap-2 align-items-center pt-3">
                                <img
                                  width={15}
                                  src={loction_icon}
                                  alt="location_icon"
                                />
                                <p className="mb-0 fs_15 fw-normal ff_inter color_darkgray">
                                  {obj.locationName}
                                </p>
                              </div>
                              <div className="d-flex gap-2 align-items-center pt-1">
                                <img
                                  width={15}
                                  src={date_icon}
                                  alt="date_icon"
                                />
                                <p className="mb-0 fs_15 fw-normal ff_inter color_darkgray">
                                  {obj.courseStartDate}
                                </p>
                              </div>
                            </div>
                            <div className="d-flex mt-4 justify-content-between align-items-center">
                              <h6 className="fs_26 fw-bold ff_inter custom-color">
                                ₹{" "}
                                {new Intl.NumberFormat("en-IN").format(
                                  obj.price,
                                )}
                              </h6>
                              <button className="mb-0 viewall_btn px-2 text-white py-1 fs_15 fw-medium ff_inter align-item-end">
                                Enroll Now
                              </button>
                            </div>
                          </div>
                        </Link>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {singleInstitutes?.Gallery?.length > 0 && (
                <div
                  ref={sectionRefs["training-gallery"]}
                  id="training-gallery"
                >
                  <h3 className="fs_21 ff_inter fw-bold color_darkgray mt-5">
                    Training Gallery
                  </h3>
                  <div className="row mt-3">
                    {singleInstitutes?.Gallery?.map((item, index) => (
                      <div className="col-md-4 mt-3" key={index}>
                        <img
                          className="w-100 h-100 object-fit-cover rounded"
                          src={item.image}
                          alt={`Gallery Image ${index}`}
                        />
                      </div>
                    ))}
                  </div>
                </div>
              )}
              {singleInstitutes?.Workshop?.length > 0 && (
                <div ref={sectionRefs.workshops} id="workshops">
                  <h4 className="fs_21 ff_inter fw-bold color_darkgray mt-5">
                    Workshops By {singleInstitutes?.Institute?.instituteName}
                  </h4>
                  <div className="row mt-2">
                    {singleInstitutes?.Workshop?.map((obj, index) => (
                      <div key={index} className="col-md-6 mt-4">
                        <img
                          height={250}
                          className="w-100 rounded-top-4 object-fit-cover"
                          src={
                            obj.workshopImage ||
                            "https://via.placeholder.com/400x250"
                          }
                          alt="workshop_image"
                        />
                        <div className="bg-white border-1 d-flex flex-column justify-content-between min_height_210 training_border p-3 rounded-bottom-4">
                          <h4 className="fs_21 fw-bold ff_inter color_darkgray mb-0">
                            {obj.workshopName}
                          </h4>
                          <div>
                            <div className="d-flex gap-2 align-items-center pt-3">
                              <img
                                width={15}
                                src={loction_icon}
                                alt="location_icon"
                              />
                              <p className="mb-0 fs_15 fw-normal ff_inter color_darkgray">
                                {obj.workshopLocationName}
                              </p>
                            </div>
                            <div className="d-flex gap-2 align-items-center pt-1">
                              <img width={15} src={date_icon} alt="date_icon" />
                              <p className="mb-0 fs_15 fw-normal ff_inter color_darkgray">
                                {obj.workshopStartDate}
                              </p>
                            </div>
                            {obj.workshopDuration && (
                              <div className="d-flex gap-2 align-items-center pt-1">
                                <FontAwesomeIcon
                                  icon={faClock}
                                  className="text-secondary fs_15"
                                />
                                <p className="mb-0 fs_15 fw-normal ff_inter color_darkgray">
                                  {obj.workshopDuration} Days
                                </p>
                              </div>
                            )}
                            {obj.workshopType && (
                              <div className="d-flex gap-2 align-items-center pt-1">
                                <FontAwesomeIcon
                                  icon={faScrewdriverWrench}
                                  className="text-secondary fs_15"
                                />
                                <p className="mb-0 fs_15 fw-normal ff_inter color_darkgray">
                                  {obj.workshopType}
                                </p>
                              </div>
                            )}
                          </div>
                          <div className="d-flex mt-4 justify-content-between align-items-center">
                            <h6 className="fs_26 fw-bold ff_inter custom-color">
                              ₹{" "}
                              {new Intl.NumberFormat("en-IN").format(
                                obj.workshopPrice,
                              )}
                            </h6>
                            <button
                              type="button"
                              className="mb-0 viewall_btn px-2 text-white py-1 fs_15 fw-medium ff_inter align-item-end"
                              onClick={() => handleWorkshopClick(obj)}
                            >
                              View Details
                            </button>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {selectedWorkshop && showModal && (
                <div className="fixed inset-0 bg-black bg-opacity-50 z-[1050] flex justify-center items-start md:items-center p-4 overflow-y-auto">
                  <div className="bg-white rounded-2xl shadow-2xl w-full max-w-[1100px] p-4 md:p-6 lg:p-8 mt-16 md:mt-32 mb-8">
                    {/* Header */}
                    <div className="flex justify-between items-center mb-4 md:mb-6">
                      <h2 className="text-xl md:text-2xl font-bold text-gray-800">
                        {selectedWorkshop.workshopName}
                      </h2>
                      <button
                        onClick={handleCloseModal}
                        className="text-gray-500 hover:text-gray-700 text-2xl bg-transparent border-none focus:outline-none"
                        aria-label="Close modal"
                      >
                        &times;
                      </button>
                    </div>

                    {/* Body */}
                    <div className="flex flex-col lg:flex-row gap-4 md:gap-6">
                      {/* Left Section */}
                      <div className="lg:w-2/3">
                        <img
                          src={selectedWorkshop.workshopImage}
                          alt="Workshop"
                          className="w-full h-48 sm:h-64 md:h-80 lg:h-96 object-cover rounded-xl mb-3 md:mb-4"
                        />
                        {selectedWorkshop.workshopDescription && (
                          <>
                            <h4 className="text-base md:text-lg font-semibold mb-1 md:mb-2">
                              About This Workshop
                            </h4>
                            <p className="text-gray-600 text-sm md:text-base leading-relaxed">
                              {selectedWorkshop.workshopDescription}
                            </p>
                          </>
                        )}
                      </div>

                      {/* Right Section */}
                      <div className="lg:w-1/3 space-y-4 md:space-y-6">
                        <div className="bg-gray-100 p-3 md:p-4 rounded-xl">
                          <h4 className="font-semibold text-sm md:text-base mb-2 md:mb-3">
                            Workshop Details
                          </h4>
                          <ul className="text-xs md:text-sm text-gray-700 space-y-1 md:space-y-2">
                            <li>
                              <strong>Location:</strong>{" "}
                              {selectedWorkshop.workshopLocationName}
                            </li>
                            <li>
                              <strong>Date:</strong>{" "}
                              {selectedWorkshop.workshopStartDate}
                            </li>
                            <li>
                              <strong>Duration:</strong>{" "}
                              {selectedWorkshop.workshopDuration} Days
                            </li>
                            <li>
                              <strong>Type:</strong>{" "}
                              {selectedWorkshop.workshopType}
                            </li>
                            <li>
                              <strong>Price:</strong> ₹
                              {new Intl.NumberFormat("en-IN").format(
                                selectedWorkshop.workshopPrice,
                              )}
                            </li>
                          </ul>
                        </div>

                        {selectedWorkshop?.workshopRequirements && (
                          <div className="bg-gray-100 p-3 md:p-4 rounded-xl">
                            <h4 className="font-semibold text-sm md:text-base mb-2 md:mb-3">
                              Requirements
                            </h4>
                            <div
                              className="text-xs md:text-sm text-gray-700 space-y-1"
                              dangerouslySetInnerHTML={{
                                __html: selectedWorkshop.workshopRequirements,
                              }}
                            />
                          </div>
                        )}
                      </div>
                    </div>

                    {/* Footer */}
                    <div className="flex flex-col-reverse sm:flex-row justify-end gap-2 md:gap-4 mt-6 md:mt-8">
                      <button
                        onClick={handleCloseModal}
                        className="px-4 py-1.5 sm:px-6 sm:py-2 rounded-full border border-gray-300 hover:bg-gray-100 text-gray-700 text-sm md:text-base"
                      >
                        Close
                      </button>
                      <button
                        className="px-4 py-1.5 sm:px-6 sm:py-2 rounded-full bg-blue-600 hover:bg-blue-700 text-white text-sm md:text-base"
                        onClick={() => {
                          setShowModal(false);
                          setShowEnrollForm(true);
                        }}
                      >
                        Enroll Now
                      </button>
                    </div>
                  </div>
                </div>
              )}

              {showEnrollForm && (
                <div className="fixed inset-0 bg-black bg-opacity-50 z-[1050] flex justify-center items-start md:items-center p-4 overflow-y-auto">
                  <div className="bg-white rounded-2xl shadow-xl w-full max-w-md md:max-w-lg lg:max-w-xl p-6">
                    {/* Header */}
                    <div className="flex justify-between items-center mb-6">
                      <h2 className="text-xl md:text-2xl font-bold text-gray-800">
                        Enroll in{" "}
                        <span className="text-blue-600">
                          {selectedWorkshop?.workshopName}
                        </span>
                      </h2>
                      <button
                        onClick={handleCloseModal}
                        className="text-gray-500 hover:text-gray-700 text-2xl bg-transparent border-none focus:outline-none"
                        aria-label="Close modal"
                      >
                        &times;
                      </button>
                    </div>

                    {/* Form */}
                    <form
                      onSubmit={handleSubmit}
                      autoComplete="off"
                      className="space-y-4"
                    >
                      {["name", "email", "phone"].map((field) => (
                        <div key={field} className="relative">
                          <input
                            type={
                              field === "email"
                                ? "email"
                                : field === "phone"
                                  ? "tel"
                                  : "text"
                            }
                            name={field}
                            id={field}
                            value={formData[field]}
                            onChange={handleChange}
                            required
                            pattern={field === "phone" ? "\\d{10}" : undefined}
                            maxLength={field === "phone" ? 10 : undefined}
                            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 peer"
                            placeholder=" "
                          />
                          <label
                            htmlFor={field}
                            className="absolute left-4 top-3 px-1 bg-white text-gray-500 transition-all duration-200 
                         peer-focus:-top-2 peer-focus:text-xs peer-focus:text-blue-600
                         peer-placeholder-shown:top-3 peer-placeholder-shown:text-base
                         peer-[&:not(:placeholder-shown)]:-top-2 peer-[&:not(:placeholder-shown)]:text-xs"
                          >
                            {field.charAt(0).toUpperCase() + field.slice(1)}
                          </label>
                        </div>
                      ))}

                      <div className="relative">
                        <textarea
                          name="address"
                          id="address"
                          rows={3}
                          value={formData.address}
                          onChange={handleChange}
                          required
                          className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 peer"
                          placeholder=" "
                        />
                        <label
                          htmlFor="address"
                          className="absolute left-4 top-3 px-1 bg-white text-gray-500 transition-all duration-200 
                       peer-focus:-top-2 peer-focus:text-xs peer-focus:text-blue-600
                       peer-placeholder-shown:top-3 peer-placeholder-shown:text-base
                       peer-[&:not(:placeholder-shown)]:-top-2 peer-[&:not(:placeholder-shown)]:text-xs"
                        >
                          Address
                        </label>
                      </div>

                      {/* Footer */}
                      <div className="flex flex-col-reverse sm:flex-row justify-end gap-3 pt-4">
                        <button
                          type="button"
                          onClick={handleCloseModal}
                          className="px-6 py-2.5 rounded-lg border border-gray-300 hover:bg-gray-50 text-gray-700 font-medium"
                        >
                          Cancel
                        </button>
                        <button
                          type="submit"
                          className="px-6 py-2.5 rounded-lg bg-blue-600 hover:bg-blue-700 text-white font-medium shadow-sm"
                        >
                          Submit Enrollment
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              )}
              {/* FAQ Button */}
              <div className="mt-5">
                <button className="btn btn-primary" onClick={handleFaqToggle}>
                  {showFaq ? "Hide FAQs" : "Show FAQs"}
                </button>
              </div>

              {/* Conditionally render FAQ section */}
              {showFaq && (
                <div ref={sectionRefs.faq} id="faq" className="mt-5">
                  <h4 className="fs_21 ff_inter fw-bold color_darkgray">
                    FAQs
                  </h4>
                  <div className="mt-4">
                    <Accordion className="mt-2" defaultActiveKey="">
                      {singleInstitutes?.Faq?.map((item, index) => (
                        <Accordion.Item
                          className=""
                          eventKey={`${index}`}
                          key={index}
                        >
                          <Accordion.Header className="fs_17 ff_inter fw-bold color_darkgray">
                            <p className="fs_17 ff_inter fw-semibold color_darkgray mb-0">
                              {item.question}
                            </p>
                          </Accordion.Header>
                          <Accordion.Body className="fs_17 ff_inter color_darkgray">
                            {item.answer}
                          </Accordion.Body>
                        </Accordion.Item>
                      ))}
                    </Accordion>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

const TabLink = ({ tabIndex, icon, title, activeTab, onClick }) => (
  <div className={`d-flex mt-3 cursor-pointer gap-3 align-items-center`}>
    <img width={23} src={icon} alt={title} />
    <a
      href={`#${title.toLowerCase().replace(" ", "-")}`}
      className={`text-decoration-none ${activeTab === tabIndex ? "custom-color" : "color_darkgray"}`}
      onClick={(e) => {
        e.preventDefault();
        onClick(tabIndex);
      }}
    >
      <p className={`mb-0 fs_18 fw-medium ff_inter`}>{title}</p>
    </a>
  </div>
);

export default SingleTrainingInstitute;
